/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Card_Support_TextInputs */

const en_contact_card_support_text = /** @type {(inputs: Contact_Card_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a question about something else?`)
};

const es_contact_card_support_text = /** @type {(inputs: Contact_Card_Support_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes una pregunta sobre algo más?`)
};

/**
* | output |
* | --- |
* | "Have a question about something else?" |
*
* @param {Contact_Card_Support_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const contact_card_support_text = /** @type {((inputs?: Contact_Card_Support_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Card_Support_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_card_support_text(inputs)
	return en_contact_card_support_text(inputs)
});